import React, { useState, useEffect, useRef } from 'react'

import Checkbox from '../../checkbox'

import * as S from '../styles'

import IProps from './props'

import { useClickOutside } from '../utils'

const SpecialtiesPopup = ({
  onApply,
  onClose,
  selectedSpecialties,
  specialtyList,
}: IProps) => {
  const [specialties, setSpecialties] = useState<Array<string>>([])

  const containerRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    setSpecialties(selectedSpecialties)
  }, [selectedSpecialties])

  const handleCheckSpecialty = (specialty: string) => {
    if (specialties.includes(specialty)) {
      setSpecialties(specialties.filter((item) => item !== specialty))
    } else {
      setSpecialties([...specialties, specialty])
    }
  }

  const handleApply = () => {
    onApply(specialties)
    onClose()
  }

  useClickOutside(
    containerRef,
    'specialty',
    'specialties',
    () => {
      onApply(specialties)
    },
    handleApply,
  )

  return (
    <S.Container ref={containerRef} className="specialties-popup">
      <S.ApplyButton onClick={handleApply}>Aplicar</S.ApplyButton>
      {specialtyList.map((specialty) => (
        <Checkbox
          key={`specialty-list-${specialty.id}`}
          id={specialty.name}
          label={specialty.name}
          checked={specialties.includes(specialty.name)}
          onCheck={() => handleCheckSpecialty(specialty.name)}
        />
      ))}
      <S.ApplyButton onClick={handleApply}>Aplicar</S.ApplyButton>
    </S.Container>
  )
}

export default SpecialtiesPopup
